module.exports = __webpack_public_path__ + "static/media/IMG_1978-2.30ba6b8b.jpg";